import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductConstants from '../../helpers/ProductConstants';

const { SAMEDAYPICKUP, NOTAVAILABLE, FREEPICKUP } = ProductConstants;

const FreePickupLabel = (props) => {
    const { sameDayPickUp = {} } = props;
    const labelDisabled =
        sameDayPickUp.availabilityMessage === NOTAVAILABLE &&
        !sameDayPickUp.skuAvailableInNearbyStore;
    const classNames = `${dt([
        'lg:!text-small',
        'font-open-sans-bold',
        labelDisabled ? 'text-gray-40' : 'text-black',
        'smMd:text-base',
    ])}`;
    return sameDayPickUp.availabilityMessage === NOTAVAILABLE ||
        isEmpty(sameDayPickUp.storeInfo) ||
        isEmpty(sameDayPickUp.pickupDateMessage) ? (
        <>
            <span className={classNames}>FREE {SAMEDAYPICKUP}</span>
        </>
    ) : (
        <>
            <span
                className={dt([
                    'font-open-sans-bold',
                    'text-black',
                    'lg:!text-small',
                    'smMd:text-base',
                ])}
            >
                <span className={dt(['font-open-sans-regular', 'pr-1'])}>{FREEPICKUP}:</span>
                {sameDayPickUp.pickupDateMessage}
            </span>
        </>
    );
};

FreePickupLabel.defaultProps = {
    sameDayPickUp: {},
};

FreePickupLabel.propTypes = {
    sameDayPickUp: PropTypes.object,
};

export default FreePickupLabel;
